import BaseApi from '@lumapps/base-api';
import { initStore as initReduxStore } from '@lumapps/redux/stores/initStore';
import { syncConnectedUserToken } from '@lumapps/user/ducks/syncConnectedUserToken';

/**
 * Initializes the redux store and wires it to BaseApi so that requests can dispatch to it (e.g. token refresh).
 */
export const initStore: typeof initReduxStore = (rootReducer, initialState, transforms, keysToIgnore) => {
    const store = initReduxStore(rootReducer, initialState, transforms, keysToIgnore);
    BaseApi.store = store;
    syncConnectedUserToken(store);
    return store;
};
